import { render, staticRenderFns } from "./landingMain.vue?vue&type=template&id=705d7976&"
import script from "./landingMain.vue?vue&type=script&lang=js&"
export * from "./landingMain.vue?vue&type=script&lang=js&"
import style0 from "./landingMain.vue?vue&type=style&index=0&id=705d7976&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports